import {
    Flex,
    useAppDisplayModeContext,
    useStyles,
} from '@archipro-design/aria';

import * as S from './PageLayout.style';
import React from 'react';
import { PAGE_KEY } from '~/modules/pagination/config/url-page-keys';
import { useSearchParams } from '@remix-run/react';

interface MainContentLayoutProps extends React.PropsWithChildren {
    topComponent: React.ReactNode;
    leftSideNav?: React.ReactNode;
}

const MainContentLayout: React.FC<MainContentLayoutProps> = ({
    children,
    topComponent,
    leftSideNav,
}) => {
    const { css } = useStyles();
    const { desktop } = useAppDisplayModeContext();

    const [searchParams] = useSearchParams();
    const page = searchParams.get(PAGE_KEY);
    const topRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (topRef.current && desktop) {
            topRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    }, [page, desktop]);

    return (
        <div className={css(S.MainContentWrapper)}>
            {topComponent}
            <Flex>
                {desktop && leftSideNav}
                <div className={css(S.Content)}>
                    <div ref={topRef} />
                    {children}
                </div>
            </Flex>
        </div>
    );
};

export default MainContentLayout;
